export default "__VITE_ASSET__BEsh0b$8__"